module.exports = __webpack_public_path__ + "img/12-2.a3ce8cef.png";